import { NavController, ViewController, AlertController, ToastController, LoadingController, NavParams } from 'ionic-angular';
import { Component } from '@angular/core';
import { UserService } from '../../services/user.services';
import { AppConfigService } from '../../services/appConfig.service';
import { AppDialog } from '../../component/appDialog';
import { CommonUtil } from '../../util/commonUtil';
@Component({
    templateUrl: 'paymentCodeView.html',
    selector: 'payment-code-view',
    // providers: [UserService, AppConfigService]
})
export class PaymentCodeViewPage {
    content: string;
    uid: string;
    title: string;
    accName: string;
    accNo: string;
    paymentCode: string;

    constructor(
        public params: NavParams,
        public loadingCtrl: LoadingController,
        private viewCtrl: ViewController,
        private nav: NavController,
        private toastCtrl: ToastController,
        private alertCtrl: AlertController,
        private userService: UserService
    ) {
        this.accName = params.get('accName');
        this.accNo = params.get('accNo');
        this.paymentCode = params.get('paymentCode');
        this.title = params.get('name');
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }
}



// WEBPACK FOOTER //
// ./src/pages/paymentCode/paymentCodeView.ts